class Form {
    constructor(config) {
        this.config = Object.assign({
            scope: 'form',
            defaultButtons: '.btn-default'
        }, config);

        this.$scope = $(this.config.scope);

        if(this.$scope.length > 0) {
            this.init();
        }
    }

    init() {
        this.addEventListeners();
        this.defaultButtons();
    }

    addEventListeners() {
        this.$scope.on('submit', this.disableButtonOnSubmit.bind(this));
    }

    disableButtonOnSubmit(e) {
        $(e.currentTarget).find('button').attr('disabled', true);
    }

    defaultButtons() {
        $(this.config.defaultButtons).on('click', function(e) {
            e.preventDefault();
        }.bind(this));
    }
}

export default new Form();
